/**
 * Lightbox simple pour galeries
 * 
 * @package g3w-theme
 * @author Gianito - G3W
 * 
 * Fonctionnalités:
 * - Clic sur image pour ouvrir en grand
 * - Navigation avec flèches clavier
 * - Fermeture avec Escape ou clic extérieur
 * - Responsive et léger
 */

(function () {
    'use strict';

    let currentImageIndex = 0;
    let galleryImages = [];
    let lightbox = null;

    // Créer la structure HTML de la lightbox
    function createLightbox() {
        const lightboxHTML = `
            <div class="g3w-lightbox" id="g3w-lightbox" style="display: none;">
                <div class="g3w-lightbox__overlay"></div>
                <div class="g3w-lightbox__container">
                    <button class="g3w-lightbox__close" aria-label="Fermer">&times;</button>
                    <button class="g3w-lightbox__prev" aria-label="Image précédente">&larr;</button>
                    <img class="g3w-lightbox__image" src="" alt="" />
                    <button class="g3w-lightbox__next" aria-label="Image suivante">&rarr;</button>
                    <div class="g3w-lightbox__counter"></div>
                </div>
            </div>
        `;

        document.body.insertAdjacentHTML('beforeend', lightboxHTML);
        lightbox = document.getElementById('g3w-lightbox');

        // Event listeners
        lightbox.querySelector('.g3w-lightbox__close').addEventListener('click', closeLightbox);
        lightbox.querySelector('.g3w-lightbox__overlay').addEventListener('click', closeLightbox);
        lightbox.querySelector('.g3w-lightbox__prev').addEventListener('click', showPrevImage);
        lightbox.querySelector('.g3w-lightbox__next').addEventListener('click', showNextImage);

        // Clavier
        document.addEventListener('keydown', handleKeydown);
    }

    // Initialiser les galeries
    function initGalleries() {
        const galleries = document.querySelectorAll('.wp-block-gallery.is-style-masonry-no-captions');

        galleries.forEach(gallery => {
            const images = gallery.querySelectorAll('.wp-block-image img');

            images.forEach((img, index) => {
                // Wrapper le lien existant ou l'image
                const link = img.closest('a');
                const targetElement = link || img;

                targetElement.addEventListener('click', function (e) {
                    e.preventDefault();

                    // Construire la liste des images de cette galerie
                    galleryImages = Array.from(images).map(image => {
                        const link = image.closest('a');
                        return {
                            src: link ? link.href : image.src,
                            alt: image.alt || ''
                        };
                    });

                    currentImageIndex = index;
                    openLightbox();
                });
            });
        });
    }

    // Ouvrir la lightbox
    function openLightbox() {
        if (!lightbox) createLightbox();

        showCurrentImage();
        lightbox.style.display = 'block';
        document.body.style.overflow = 'hidden';

        // Focus sur la lightbox pour l'accessibilité
        lightbox.focus();
    }

    // Fermer la lightbox
    function closeLightbox() {
        if (lightbox) {
            lightbox.style.display = 'none';
            document.body.style.overflow = '';
        }
    }

    // Afficher l'image courante
    function showCurrentImage() {
        if (!galleryImages.length) return;

        const currentImage = galleryImages[currentImageIndex];
        const img = lightbox.querySelector('.g3w-lightbox__image');
        const counter = lightbox.querySelector('.g3w-lightbox__counter');

        img.src = currentImage.src;
        img.alt = currentImage.alt;

        counter.textContent = `${currentImageIndex + 1} / ${galleryImages.length}`;

        // Masquer/afficher les boutons de navigation
        const prevBtn = lightbox.querySelector('.g3w-lightbox__prev');
        const nextBtn = lightbox.querySelector('.g3w-lightbox__next');

        prevBtn.style.display = currentImageIndex === 0 ? 'none' : 'block';
        nextBtn.style.display = currentImageIndex === galleryImages.length - 1 ? 'none' : 'block';
    }

    // Image précédente
    function showPrevImage() {
        if (currentImageIndex > 0) {
            currentImageIndex--;
            showCurrentImage();
        }
    }

    // Image suivante
    function showNextImage() {
        if (currentImageIndex < galleryImages.length - 1) {
            currentImageIndex++;
            showCurrentImage();
        }
    }

    // Gestion du clavier
    function handleKeydown(e) {
        if (lightbox && lightbox.style.display === 'block') {
            switch (e.key) {
                case 'Escape':
                    closeLightbox();
                    break;
                case 'ArrowLeft':
                    showPrevImage();
                    break;
                case 'ArrowRight':
                    showNextImage();
                    break;
            }
        }
    }

    // Initialiser quand le DOM est prêt
    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', initGalleries);
    } else {
        initGalleries();
    }

})(); 